/**
 * Created by mateimisarca on 2019-06-15
 */

import PartnersPage from './partners-page';

export default PartnersPage;
